export const getPromptEditorAutofillProps = (name: string) =>
      ({
            name,
            autoComplete: "off",
            "data-1p-ignore": "true",
            "data-op-ignore": "true",
            "data-lpignore": "true",
            "data-bwignore": "true",
      }) as const;
